import familyZoningApproved from "../../../../content/news/2025-12-02-family-zoning-approved/board-approves-luries-family-zoning.png";
import popularHousingNews from "../../../../content/research/2025-07-28-how-popular-is-housing/people-homes-businesses.jpg";
import policeNews from "../../../../content/advocacy/family-zoning/police-news.jpeg";
import businessesNews from "../../../../content/advocacy/family-zoning/businesses-news.jpeg";
import radicalizingNews from "../../../../content/advocacy/family-zoning/radicalizing-news.jpeg";
import emotionsNews from "../../../../content/advocacy/family-zoning/emotions-news.jpeg";
import openLetterImage from "../../../../content/advocacy/family-zoning/open-letter-to-opponents/open-letter.png";
import * as React from 'react';
export default {
  familyZoningApproved,
  popularHousingNews,
  policeNews,
  businessesNews,
  radicalizingNews,
  emotionsNews,
  openLetterImage,
  React
};